import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UserService, DecodeJWTService, RegistrationStateService } from './services';

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [DecodeJWTService, RegistrationStateService, UserService]
})
export class RegistrationModule {}
